






























































































import { Component, Vue } from "vue-property-decorator";
import TaxEventDTO from "@/dto/tax/TaxEventDTO";
import TaxEventPayload from "@/dto/tax/TaxEventPayload";
import TaxEventCommentPayload from "@/dto/tax/TaxEventCommentPayload";
import TaxEventService from "@/services/TaxEventService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import DictionarySelect from "@/components/common/DictionarySelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import moment from "moment";
import { CounterpartyType } from "@/constants/CounterpartyType";

@Component({
  components: {
    SimpleProfileSearch,
    DictionarySelect,
    PortalInput,
    PortalTextarea
  }
})
export default class TaxEvent extends Vue {
  
  taxEvent: TaxEventDTO | null = null;
  form: Partial<TaxEventPayload> = {};
  amountLocal: number | string = '';

  commentPayload: TaxEventCommentPayload = new TaxEventCommentPayload();

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get sortedComments() {
    if (!this.taxEvent || !this.taxEvent.comments) return [];
    return [...this.taxEvent.comments].sort((a, b) => 
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }

  mounted(): void {
    this.loadEvent();
  }

  loadEvent(): void {
    Application.startLoading();
    TaxEventService.getTaxEvent(this.id).then(
      res => {
        this.taxEvent = res.data;
        this.populateForm();
        Application.stopLoading();
      },
      err => processError(err, this)
    );
  }

  populateForm(): void {
    if (!this.taxEvent) return;
    this.form = {
      eventDate: this.taxEvent.eventDate,
      paidOn: this.taxEvent.paidOn,
      amountCents: this.taxEvent.amountCents,
      taxTypeId: this.taxEvent.taxType ? this.taxEvent.taxType.id as number : null as any,
      customerId: this.taxEvent.customerId,
      customerType: this.taxEvent.customerType
    };
    
    if (this.taxEvent.amountCents) {
      this.amountLocal = (this.taxEvent.amountCents / 100).toFixed(2);
    } else {
      this.amountLocal = '';
    }
  }
  
  get isValid(): boolean {
    if (this.$validator && this.$validator.errors.items.length > 0) return false;
    return !!(this.form.customerId && this.form.taxTypeId && this.amountLocal && this.form.eventDate);
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY');
  }

  formatDateTime(dateStr: string): string {
    if (!dateStr) return "-";
    return moment(dateStr).format('MM-DD-YYYY HH:mm');
  }

  async save(): Promise<void> {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.isValid) return;

    if (this.amountLocal) {
        this.form.amountCents = Math.round(parseFloat(this.amountLocal.toString()) * 100);
    }

    Application.startLoading();
    TaxEventService.updateTaxEvent(this.id, this.form as TaxEventPayload).then(
      res => {
        Application.stopLoading();
        // Optional: show toast message or redirect. Just reload to show updated DTO state.
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }

  addComment(): void {
    if (!this.commentPayload.comment.trim()) return;
    
    Application.startLoading();
    TaxEventService.addComment(this.id, this.commentPayload).then(
      res => {
        Application.stopLoading();
        this.commentPayload = new TaxEventCommentPayload();
        this.loadEvent();
      },
      err => processError(err, this)
    );
  }
}
